import clsx from 'clsx'
import { WalletIcon } from 'lucide-react'

import { Banner } from 'slab'
import { getLocaleCurrencyStringFromNumber } from 'utils'

type Props = {
  subtotal: number;
  thatchBalance: number;
  hideSuccessBanner?: boolean;
}

export default function CostBreakdown ({
  subtotal,
  thatchBalance,
  hideSuccessBanner,
}: Props) {
  const totalDue = Math.max(0, subtotal - thatchBalance)
  const appliedBalance = Math.min(thatchBalance, subtotal)
  const hasAppliedBalance = appliedBalance > 0

  return (
    <div className='flex flex-col gap-4'>
      <div className='flex flex-col gap-1'>
        <div className='flex flex-row justify-between gap-2 body-sm'>
          <span className='text-gray-500'>Subtotal</span>
          <span>{getLocaleCurrencyStringFromNumber(subtotal, { maximumFractionDigits: 2 })}</span>
        </div>
        <div className={clsx(
          'flex flex-row justify-between gap-2 body-sm',
          {
            'text-green-400': hasAppliedBalance,
            'text-gray-500': !hasAppliedBalance
          })}
        >
          <span>Thatch balance applied</span>
          <span>
            {hasAppliedBalance ? '-' : ''}
            {getLocaleCurrencyStringFromNumber(Math.abs(appliedBalance), { maximumFractionDigits: 2 })}
          </span>
        </div>
      </div>
      <div className='flex flex-row justify-between gap-2 body-bold'>
        <span>Total due</span>
        <span>{getLocaleCurrencyStringFromNumber(totalDue, { maximumFractionDigits: 2 })}</span>
      </div>

      {!hideSuccessBanner && totalDue === 0 && (
        <Banner
          type='success'
          title='Your Thatch balance covers the full cost. Just click "Complete purchase" to finalize your purchase.'
          icon={WalletIcon}
        />
      )}
    </div>
  )
}
